import { Link } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { useAuth } from 'react-oidc-context'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { CommunityCard } from '@/components/community/community-card'
import { useCommunities } from '@/features/communities/use-communities'

export const CommunityDirectoryPage = () => {
  const auth = useAuth()
  const { data, isLoading, isError, refetch } = useCommunities(0)

  return (
    <div className="mx-auto w-full max-w-5xl space-y-6 px-4 py-6">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Communities</h1>
          <p className="text-sm text-muted-foreground">
            Build alongside others working on similar things.
          </p>
        </div>
        {auth.isAuthenticated && (
          <Button asChild className="gap-2">
            <Link to="/communities/new">
              <Plus className="h-4 w-4" />
              New community
            </Link>
          </Button>
        )}
      </div>

      {isLoading && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-44 w-full" />
          ))}
        </div>
      )}

      {isError && (
        <Alert variant="destructive">
          <AlertTitle>Couldn&apos;t load communities</AlertTitle>
          <AlertDescription>
            <button
              type="button"
              onClick={() => refetch()}
              className="underline underline-offset-2"
            >
              Retry
            </button>
          </AlertDescription>
        </Alert>
      )}

      {data && data.content.length === 0 && (
        <div className="rounded-md border bg-background p-8 text-center">
          <p className="text-base font-medium">No communities yet.</p>
          {auth.isAuthenticated && (
            <p className="mt-2 text-sm text-muted-foreground">
              Be the first —{' '}
              <Link to="/communities/new" className="underline underline-offset-2">
                create one
              </Link>
              .
            </p>
          )}
        </div>
      )}

      {data && data.content.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data.content.map((c) => (
            <CommunityCard key={c.id} community={c} />
          ))}
        </div>
      )}
    </div>
  )
}
